module App.Appointments {
	import Package = App.PriceGuide.Package;
	import PaymentType = App.Payment.PaymentType;
	import Questionnaire = App.Questionnaire.Questionnaire;

	export type Tag = {
		id: number;
		name: string;
	};

	export type TagType = {
		id: number;
		name: string;
		tags: Tag[];
	}

	export type Department = {
		id: number;
		name: string;
		tag_types: TagType[];
	}

	export type DispatchCode = {
		id: number;
		name: string;
	}

	export type LeadSource = {
		id: number;
		name: string;
		description: string;
		number: number;
		status: boolean;
	}

	export type Salesman = {
		id: number;
		name: string;
	}

	export type ServiceNote = {
		id: number;
		description: string;
	}

	export type ServiceAddress = {
		latitude: string;
		longitude: string;
		address: string;
		id: number;
		location?: Location;
		street?: string;
		city?: string;
		state?: string;
		zip?: string;
	}

	export type ServicePlanAgreement = {
		id: number;
		active: boolean;
		service_plan: ServicePlan;
		expiry: string;
	}

	export type Customer = {
		id: number;
		full_name?: string;
		company_name?: string;
		first_name?: string;
		last_name?: string;
		home_phone?: string;
		mobile_phone?: string;
		work_phone?: string;
		emails?: Email[];
		able_to_bill?: boolean;
		last_service_plan?: ServicePlanAgreement;
		rate_mode?: RateMode;
		rate_type?: RateType;
		phone_numbers?: PhoneNumber[];
		can_show_financing?: boolean;
		tags?: Tag[];
		recolor_tag?: Tag;
		files?: File[];
	}

	export type File = {
		id?: number;
		url: string;
		file_type: string;
		name: string;
	}

	export type Email = {
		id: number;
		email: string;
		marketing: boolean;
	}

	export type RateMode = {
		[key: string]: boolean|string;
		default_mode_name: string;
		regular: boolean;
		itemized: boolean;
		whilehere: boolean;
		admin: boolean;
		finance: boolean;
		service_plan: boolean;
	}

	export type ServiceRequestType = {
		id?: number;
		name: string;
	}

	export type RateType = {
		id: number;
		name: string;
	}

	export type ServiceRequest = {
		[key: string]: any;

		id: number;
		service_address?: ServiceAddress;
		service_request_type?: ServiceRequestType;
		service_plan?: ServicePlan;
		finance_plan?: FinancePlan;
		notes?: ServiceNote[];
		promised_date?: string;
		promised_time?: string;
		service_request_status?: string;
		payment_type?: PaymentType;
		appointments?: Appointment[];
		dispatch_code?: DispatchCode;
		department?: Department;
		packages?: Package[];
		customer?: Customer;
		location?: Location;
		tags?: Tag[];
		amount_due?: string;
		total?: string;
		questionnaire?: Questionnaire;
		can_show_regular_pricing?: boolean;
	}

	export type ServicePlan = {
		id: number | string;
		name: string;
		notes: string;
		term: 'monthly' | 'annual';
		visits_per_year: number;
		cost: number;
		savings: string;
		expire_date: Date;
		default_service_plan: boolean;
	}

	export type FinancePlan = {
		id: number;
		min_invoice: number;
		min_payment: number;
		visible: boolean;
		payment: number;
		notes: string|null;
		finance_company?: FinanceCompany;
		default_finance_plan: boolean;
		name: string;
		amount: string;
	}

	export type FinanceCompany = {
		id: number;
		name: string;
		plans?: FinancePlan[];
	}

	export interface Appointment {
		[key: string]: any;

		id?: number;
		appointment_status?: string;
		service_request: ServiceRequest;
		scheduled_date: string; // YYYY-MM-DD
		scheduled_time: string; // HH:mm
		scheduled_duration: number;
		estimated_completion_time: string; // hh:mm
		technician?: number;
		is_partial?: boolean;
	}

	export interface AppointmentDataSet {
		today: Appointment[];
		past: Appointment[];
	}

	export type PhoneNumber = {
		id?: number;
		number: string;
		send_text: boolean;
		telephony_ext?: string;
	}
}